// extracted by mini-css-extract-plugin
export default {"notifications-link":"notifications-link_notifications-link__xUzoM","bell-wrapper":"notifications-link_bell-wrapper__Qf+1u","counter":"notifications-link_counter__CO1JG"};